import useChallengesQuery from "@hooks/common/challenges/use-challenges-query";
import { useCallback } from "react";
import { useApiSession } from "@Context/common/general/api-session-context";
import ChallengeLeagueTags from "@Enums/ChallengeLeagueTags";

const useBootcampChallenges = (userId?: string | null) => {
  const {
    refetch,
    challenges: data,
    isPending: loading,
  } = useChallengesQuery(
    {
      include_tags: [ChallengeLeagueTags.BOOTCAMP],
      exclude_tags: [],
      limit: 7,
      order_by: [{ field: "unlocked_at", direction: "asc" }],
    },
    { userId: userId ?? null }
  );

  const firebaseUid = useApiSession();
  const refreshChallenges = useCallback(() => {
    if (firebaseUid && userId) void refetch();
  }, [firebaseUid, userId, refetch]);

  return {
    challenges: data ?? [],
    loading,
    refreshChallenges,
  };
};

export default useBootcampChallenges;
